import { createAsyncThunk, createSlice, } from "@reduxjs/toolkit";
import axios from "../../api/axios";

const MOCK_ORDERS_KEY = 'mock_orders';

const getMockOrders = () => {
  const orders = localStorage.getItem(MOCK_ORDERS_KEY);
  return orders ? JSON.parse(orders) : {};
};

const saveMockOrders = (orders) => {
  localStorage.setItem(MOCK_ORDERS_KEY, JSON.stringify(orders));
};

export const getUserOrder = createAsyncThunk('order/getUserOrder', async ({ user }, { rejectWithValue }) => {
  try {
    // Try to fetch from database first
    try {
      const response = await axios.get(`/orders/${user}`);
      return response.data;
    } catch (error) {
      // Fallback to localStorage if API fails
      return new Promise((resolve) => {
        setTimeout(() => {
          const allOrders = getMockOrders();
          const userOrders = allOrders[user] || [];
          resolve(userOrders);
        }, 300);
      });
    }
  } catch (err) {
    return rejectWithValue(err)
  }
}
)

export const createOrder = createAsyncThunk('order/createOrder', async (orderData, { getState, rejectWithValue }) => {
  try {
    // Save to database
    const dbOrder = {
      userId: orderData.user,
      totalAmount: orderData.amount,
      paymentMethod: orderData.paymentMethod || 'paypal',
      paymentID: orderData.paymentID || '',
      advanceAmount: orderData.advanceAmount || null,
      remainingAmount: orderData.remainingAmount || null,
      address: orderData.address
    };
    
    const response = await axios.post('/orders', dbOrder);
    console.log('Order saved to database:', response.data);
    
    // Also save to localStorage for backward compatibility
    return new Promise((resolve) => {
      setTimeout(() => {
        const allOrders = getMockOrders();
        const userOrders = allOrders[orderData.user] || [];
        
        // PREVENT DUPLICATED ORDER
        const existingOrder = userOrders.find(item => item.paymentID === orderData.paymentID);
        
        if (!existingOrder) {
          const newOrder = {
            ...orderData,
            _id: Date.now().toString(),
            createdAt: new Date().toISOString(),
            status: 'pending',
            paymentMethod: orderData.paymentMethod || 'paypal',
            advanceAmount: orderData.advanceAmount || null,
            remainingAmount: orderData.remainingAmount || null
          };
          
          userOrders.push(newOrder);
          allOrders[orderData.user] = userOrders;
          saveMockOrders(allOrders);
        }
        
        resolve(userOrders);
      }, 300);
    });
  } catch (err) {
    console.error('Error creating order:', err);
    return rejectWithValue(err)
  }
}
)


const orderSlice = createSlice({
  name: "order",
  initialState: {
    loading: false,
    error: false,
    success: false,
    errMsg: '',
    orders: [],
  },
  reducers: {
  },
  extraReducers: {
    [getUserOrder.pending]: (state) => {
      state.loading = true
      state.error = false
    },
    [getUserOrder.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.orders = payload
      state.errorMsg = ''
    },
    [getUserOrder.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = true
      state.errorMsg = payload
      state.success = false
    },
    [createOrder.pending]: (state) => {
      state.loading = true
      state.error = false
      state.success = false
    },
    [createOrder.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.orders = payload
      state.errorMsg = ''
      state.success = true
    },
    [createOrder.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = true
      state.errorMsg = payload.msg ? payload.msg : payload
      state.success = false
    }
  }
})

export default orderSlice.reducer
